import React from "react";
import "./styles.css";
import participants from "../../data/participants.json";
import Back from "../Back";
import Card from "../Card";
import ScrollToTop from "../ScrollToTop";
import { ParticipantsContainer, ParticipantsH1 } from "./ParticipantElements";

/*
    {
        "name": "",
        "institution": "",
        "LSST": ""
    },
*/

const Participants = () => {
    return (
        <>
            <ScrollToTop />
            <Back />
            <ParticipantsH1>Participantes</ParticipantsH1>
            <div className="stars">
                <div className="twinkling">
                    <div className="clouds">
                        <ParticipantsContainer>
                            {participants &&
                                participants.map((p, index) => {
                                    return (
                                        <Card
                                            key={index}
                                            img={p.img}
                                            name={p.name}
                                            institution={p.institution}
                                            LSST={p.LSST}
                                            title={p.c_title}
                                            description={p.abstract}
                                            invitado={p.invitado}
                                        />
                                    );
                                })}
                        </ParticipantsContainer>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Participants;
